import { render } from "./HeaDer.vue?vue&type=template&id=22855a11&scoped=true"
import script from "./HeaDer.vue?vue&type=script&lang=js"
export * from "./HeaDer.vue?vue&type=script&lang=js"

import "./HeaDer.vue?vue&type=style&index=0&id=22855a11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22855a11"]])

export default __exports__